import { render, staticRenderFns } from "./other-services.vue?vue&type=template&id=0e713e8f&"
import script from "./other-services.vue?vue&type=script&lang=js&"
export * from "./other-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports